import React from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { translate } from "react-translate";
import DoctorUsersForm from 'components/ListDoctorUsers/DoctorUsersForm';
//import ListPractices from 'components/ListPractices/testHooks';

const DoctorUsersEdit = (props) => {
  const {t} = props;
  
  return (
    <div className='content user-manual'>
      <Card>
        <CardHeader>
          <h5 className="title">{t("title-header")}</h5>
        </CardHeader>
        <CardBody>
          <DoctorUsersForm />
        </CardBody>
      </Card>
    </div>
  );
};

export default translate("userList")(DoctorUsersEdit);